import React from 'react';

export const ArrowDropDown = (props) => (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 16L20 8H4L12 16Z" />
    </svg>
);

export default ArrowDropDown;
